const DrawSVGUtils = require('../../../viscomjs/utils/DrawSVGUtils');
const drawSVGUtils = {};
DrawSVGUtils.mixin(drawSVGUtils);

const multiplyVec = (v, a) => {
    return v.map(x => a * x)
};

module.exports = (r, a, state) => {
    const v = multiplyVec([Math.cos(a) - state.cx / state.r,  -Math.sin(a) - state.cy / state.r], r);

    return [drawSVGUtils.round(state.cx + v[0]), drawSVGUtils.round(state.cy + v[1])];
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/svgAnim/fromPolarToCartesian.js